import Vue from 'vue'
import VueRouter from 'vue-router'
import Applayout from "@/layout/app";
import { useAuthStore } from '@/stores';

Vue.use(VueRouter)

const routes = [
    {
        path: "/",
        component: Applayout,
        children: [
            {
                path: "/",
                name: "메인",
                component: () => import("./views/app/index"),
                meta: {
                    auth: false,
                    title: '디비로봇 - DBROBOT | 법인, 기업, 사업자, 인허가 DB',
                    subTitle: '',
                    description: '디비로봇 - 법인, 기업, 사업자, 인허가 데이터베이스 제공 서비스. 정확하고 신뢰할 수 있는 기업정보를 제공합니다.',
                    keywords: '디비로봇, DBROBOT, 법인DB, 기업DB, 사업자DB, 인허가DB, 기업정보, 데이터베이스'
                }
            },
            {
                path: "company",
                name: "company",
                component: () => import("./views/app/company"),
                meta: {
                    auth: false,
                    title: '회사소개 - 디비로봇',
                    subTitle: '',
                    description: '디비로봇 회사소개 - 정확하고 신뢰할 수 있는 기업정보 데이터베이스 서비스를 제공합니다.',
                    keywords: '디비로봇, 회사소개, 기업정보, 데이터베이스'
                }
            },
            {
                path: "database/corp",
                name: "corp",
                component: () => import("./views/app/corp"),
                meta: {
                    auth: false,
                    title: '법인 DB - 디비로봇',
                    subTitle: '',
                    description: '국내 전체 법인 데이터베이스 조회 서비스. 정확하고 최신의 법인정보를 제공합니다.',
                    keywords: '법인DB, 법인정보, 법인검색, 디비로봇, 기업정보'
                }
            },
            {
                path: "database/office",
                name: "office",
                component: () => import("./views/app/office"),
                meta: {
                    auth: false,
                    title: '기업 DB - 디비로봇',
                    subTitle: '',
                    description: '국내 전체 기업 데이터베이스 조회 서비스. 정확하고 최신의 기업정보를 제공합니다.',
                    keywords: '기업DB, 기업정보, 기업검색, 디비로봇, 회사정보'
                }
            },
            {
                path: "database/licensedb",
                name: "licensedb",
                component: () => import("./views/app/licensedb"),
                meta: {
                    auth: false,
                    title: '인허가 DB - 디비로봇',
                    subTitle: '',
                    description: '국내 전체 인허가 데이터베이스 조회 서비스. 정확하고 최신의 인허가 정보를 제공합니다.',
                    keywords: '인허가DB, 인허가정보, 인허가검색, 디비로봇, 면허정보'
                }
            },
            {
                path: "database/business",
                name: "business",
                component: () => import("./views/app/business"),
                meta: {
                    auth: false,
                    title: '사업자 DB - 디비로봇',
                    subTitle: '',
                    description: '국내 전체 사업자 데이터베이스 조회 서비스. 정확하고 최신의 사업자 정보를 제공합니다.',
                    keywords: '사업자DB, 사업자정보, 사업자검색, 디비로봇, 사업자번호'
                }
            },
            {
                path: "database/:type",
                name: "database",
                component: () => import("./views/app/database"),
                meta: {
                    auth: false,
                    title: '데이터베이스 - 디비로봇',
                    subTitle: '',
                    description: '디비로봇 데이터베이스 조회 서비스. 다양한 기업 정보를 제공합니다.',
                    keywords: '데이터베이스, 기업정보, 디비로봇'
                }
            },
            {
                path: "category-search",
                name: "category-search",
                component: () => import("./views/app/category-search"),
                meta: {
                    auth: false,
                    title: '업종별 검색 - 디비로봇',
                    subTitle: '',
                    description: '업종별 기업 검색 서비스. 원하는 업종의 기업정보를 빠르게 찾을 수 있습니다.',
                    keywords: '업종별검색, 업종검색, 기업검색, 디비로봇'
                }
            },
            {
                path: "category-search/:category",
                name: "category-search-with-param",
                component: () => import("./views/app/category-search"),
                meta: {
                    auth: false,
                    title: '업종별 검색 - 디비로봇',
                    subTitle: '',
                    description: '업종별 기업 검색 서비스. 원하는 업종의 기업정보를 빠르게 찾을 수 있습니다.',
                    keywords: '업종별검색, 업종검색, 기업검색, 디비로봇'
                }
            },
            {
                path: "faq",
                name: "faq",
                component: () => import("./views/app/faq"),
                meta: {
                    auth: false,
                    title: '자주 묻는 질문 - 디비로봇',
                    subTitle: '',
                    description: '디비로봇 서비스 이용 시 자주 묻는 질문과 답변을 확인하세요.',
                    keywords: 'FAQ, 자주묻는질문, 디비로봇, 고객지원'
                }
            },
            {
                path: "license",
                name: "license",
                component: () => import("./views/app/license"),
                meta: {
                    auth: false,
                    title: '이용약관 - 디비로봇',
                    subTitle: '',
                    description: '디비로봇 서비스 이용약관을 확인하세요.',
                    keywords: '이용약관, 약관, 디비로봇'
                }
            },
            {
                path: "mypage",
                name: "mypage",
                component: () => import("./views/app/myPage"),
                meta: {
                    auth: true,
                    title: '마이페이지 - 디비로봇',
                    subTitle: '',
                    description: '디비로봇 마이페이지. 회원정보 및 이용내역을 확인하세요.',
                    keywords: '마이페이지, 회원정보, 디비로봇'
                }
            },
            {
                path: "mydelete",
                name: "mydelete",
                component: () => import("./views/app/myDelete"),
                meta: {
                    auth: true,
                    title: '회원탈퇴 - 디비로봇',
                    subTitle: '',
                    description: '디비로봇 회원탈퇴 페이지입니다.',
                    keywords: '회원탈퇴, 디비로봇'
                }
            },
            {
                path: "myupdate",
                name: "myupdate",
                component: () => import("./views/app/myUpdate"),
                meta: {
                    auth: true,
                    title: '회원정보수정 - 디비로봇',
                    subTitle: '',
                    description: '디비로봇 회원정보 수정 페이지입니다.',
                    keywords: '회원정보수정, 정보수정, 디비로봇'
                }
            },
            {
                path: "notice",
                name: "notice",
                component: () => import("./views/app/notice"),
                meta: {
                    auth: false,
                    title: '공지사항 - 디비로봇',
                    subTitle: '',
                    description: '디비로봇 공지사항 및 최신 소식을 확인하세요.',
                    keywords: '공지사항, 소식, 디비로봇'
                }
            },
            {
                path: "noticeDetail",
                name: "noticeDetail",
                component: () => import("./views/app/noticeDetail"),
                meta: {
                    auth: false,
                    title: '공지사항 상세 - 디비로봇',
                    subTitle: '',
                    description: '디비로봇 공지사항 상세 내용을 확인하세요.',
                    keywords: '공지사항, 디비로봇'
                }
            },
            {
                path: "signup",
                name: "signup",
                component: () => import("./views/app/signup"),
                meta: {
                    auth: false,
                    title: '회원가입 - 디비로봇',
                    subTitle: '',
                    description: '디비로봇 회원가입 페이지. 지금 가입하고 다양한 기업정보를 이용하세요.',
                    keywords: '회원가입, 가입, 디비로봇'
                },
            },
            {
                path: "logout",
                name: "logout",
                component: () => import("./views/app/logout"),
                meta: {
                    auth: true,
                    title: '로그아웃 - 디비로봇',
                    subTitle: '',
                    description: '디비로봇 로그아웃',
                    keywords: '로그아웃, 디비로봇'
                },
            },
        ]
    },
]

const router = new VueRouter({
    linkActiveClass: 'active',
    routes,
    mode: 'history',
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
})



// 동적 메타 태그 업데이트 함수
function updateMetaTags(route) {
    const defaultTitle = '디비로봇 - DBROBOT';
    const defaultDescription = '디비로봇 - 법인, 기업, 사업자, 인허가 데이터베이스 제공 서비스. 정확하고 신뢰할 수 있는 기업정보를 제공합니다.';
    const defaultKeywords = '디비로봇, DBROBOT, 법인DB, 기업DB, 사업자DB, 인허가DB, 기업정보, 데이터베이스';
    const defaultUrl = 'https://www.dbrobot.co.kr';

    // Title 업데이트
    document.title = route.meta.title || defaultTitle;

    // Meta Description 업데이트
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
        metaDescription.setAttribute('content', route.meta.description || defaultDescription);
    }

    // Meta Keywords 업데이트
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
        metaKeywords.setAttribute('content', route.meta.keywords || defaultKeywords);
    }

    // OG Tags 업데이트
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
        ogTitle.setAttribute('content', route.meta.title || defaultTitle);
    }

    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
        ogDescription.setAttribute('content', route.meta.description || defaultDescription);
    }

    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
        const fullUrl = defaultUrl + (route.path === '/' ? '' : route.path);
        ogUrl.setAttribute('content', fullUrl);
    }

    // Twitter Card 업데이트
    let twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
        twitterTitle.setAttribute('content', route.meta.title || defaultTitle);
    }

    let twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
        twitterDescription.setAttribute('content', route.meta.description || defaultDescription);
    }

    let twitterUrl = document.querySelector('meta[name="twitter:url"]');
    if (twitterUrl) {
        const fullUrl = defaultUrl + (route.path === '/' ? '' : route.path);
        twitterUrl.setAttribute('content', fullUrl);
    }
}

router.beforeEach(async (to,from, next) => {
    // 메타 태그 업데이트
    updateMetaTags(to);

    if(to.meta.auth == false || to.meta.auth ==undefined){
        next()
        return
    }
    const auth = useAuthStore();
    if (to.meta.auth == true && (auth.accessToken == null|| !auth.accessToken)) {
        next('/')
        return
    }
    return next()
});

export default router;